import { render, staticRenderFns } from "./MetroConnectMplsDetails.vue?vue&type=template&id=50aa3c66&"
import script from "./MetroConnectMplsDetails.vue?vue&type=script&lang=js&"
export * from "./MetroConnectMplsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports